import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import IdcardTwoToneSvg from "@ant-design/icons-svg/es/asn/IdcardTwoTone";
import AntdIcon from "../components/AntdIcon";
var IdcardTwoTone = function IdcardTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: IdcardTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  IdcardTwoTone.displayName = 'IdcardTwoTone';
}
export default /*#__PURE__*/React.forwardRef(IdcardTwoTone);